import { render } from "./TreatmentNotesCard.vue?vue&type=template&id=23604f78&scoped=true&ts=true"
import script from "./TreatmentNotesCard.vue?vue&type=script&lang=ts"
export * from "./TreatmentNotesCard.vue?vue&type=script&lang=ts"

import "./TreatmentNotesCard.vue?vue&type=style&index=0&id=23604f78&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23604f78"]])

export default __exports__